import { IState } from '../../store';
import { selectAgentLists } from '../offerData/selectAgentLists';

export function getPromoLabelContent(state: IState) {
  const { offerData, auctionBanks } = state;
  const agentLists = selectAgentLists(state);

  const isFromBank = !!offerData.agent?.bank;
  const isAuctionObject =
    auctionBanks && offerData.offer.publishedUserId && auctionBanks.includes(offerData.offer.publishedUserId);

  if (agentLists.length > 0) {
    return;
  }

  if (isFromBank && !isAuctionObject) {
    return 'Залоговая недвижимость';
  }
  if (isFromBank && isAuctionObject) {
    return 'Залоговая недвижимость, аукцион';
  }

  return offerData.offer.promoLabel;
}
